import { TableRow, TablePagination } from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";

export const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F2F4F8",
    color: "#000000",
    fontFamily: "PoppinsMedium",
    zIndex: 0,
    cursor: "pointer"
  },
  [`&.${tableCellClasses.body}`]: {
    color: "#000000",
    fontFamily: "PoppinsRegular",
    borderBottom: "1px solid #E9EDF4",
  },
}));

export const StyledTableRow = styled(TableRow)(() => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const blue = {
  200: "#A5D8FF",
  400: "#3399FF",
};

export const CustomTablePagination = styled(TablePagination)(
  () => `
    & .MuiTablePagination-spacer {
      display: none;
    }
  
    & .MuiToolbar-root {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      background-color: transparent;
  
      @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
      }
    }
  
    & .MuiTablePagination-selectLabel {
      margin: 0;
    }
  
    & .MuiSelect-root {
      font-family: "PoppinsRegular";
      padding: 2px 0 2px 4px;
      border: 1px solid #8F84F9;
      border-radius: 6px; 
      background-color: #E3E3FC;
      transition: all 100ms ease;
      &:focus {
        border-color: #8F84F9;
      }
    }
  
    & .MuiTablePagination-displayedRows {
      margin: 0;
  
      @media (min-width: 768px) {
        margin-left: auto;
      }
    }
  
    & .MuiTablePagination-actions {
      display: flex;
      gap: 6px;
      border: transparent;
      text-align: center;
    }
  
    & .MuiTablePagination-actions > button {
      display: flex;
      align-items: center;
      padding: 0;
      border-radius: 50%; 
      background-color: transparent;
      transition: all 100ms ease;
  
      > svg {
        font-size: 22px;
      }
  
      &:focus {
        border-color: ${blue[400]};
      }
  
      &:disabled {
        opacity: 0.3;
  
        &:hover {
          background-color: transparent;
        }
      }
    }
`
);